module.exports = __webpack_public_path__ + "img/ticket-header-circle.0cf1238e.svg";